import EngineeringContext from './EngineeringContext';

const EngineeringLayout = () => {
  return <EngineeringContext />;
};

export default EngineeringLayout;
